import { Flex, Typography } from '@banhala/ui-kit';
import { isNil } from 'shared/src/utils';
import React from 'react';

export const HomeWebView: React.FC<{
  url?: string;
}> = props => {
  if (isNil(props.url)) return null;

  return (
    <Flex flex={1} alignItems={'center'} justifyContent={'center'}>
      <Typography>HOME WEB VIEW 추가해주세요</Typography>
      {/*<RNAblyWebView*/}
      {/*  source={{ uri: props.url }}*/}
      {/*  scrollEnabled={false}*/}
      {/*  style={{ flex: 1 }}*/}
      {/*  onHeightChange={() => {}}*/}
      {/*/>*/}
      {/*{isFetching && (*/}
      {/*  <View style={styles.spinnerContainer}>*/}
      {/*    <Spinner size={20} />*/}
      {/*  </View>*/}
      {/*)}*/}
      {/*<AtomicRenderer*/}
      {/*  refetch={refetch}*/}
      {/*  data={data ?? []}*/}
      {/*  fetchNextPage={fetchNextPage}*/}
      {/*  listRef={atomicRendererRef}*/}
      {/*  filterListIndex={filterListIndex}*/}
      {/*  scrollToFilterList={scrollToFilterList}*/}
      {/*  isFetching={isFetching}*/}
      {/*/>*/}
    </Flex>
  );
};
